import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import styles from './ListItem.module.scss';
import { BRAND } from '../../constants/brand';

interface ListItemProps {
  className?: string;
  type: string;
}

const ListItem: FunctionComponent<ListItemProps> = ({
  children,
  className,
}) => {
  const listItemClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-list-item`,
    className,
    {
      [styles.listItem]: true,
    },
  );

  return <li className={listItemClass}>{children}</li>;
};

export default ListItem;
